// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__6ZWdA","logoBox":"NavBar_logoBox__-2ZO3","libraryBox":"NavBar_libraryBox__qOIcB","link":"NavBar_link__u2LLj","title":"NavBar_title__wxJC6"};